import React from 'react';
import SelectComponent from "../../../components/select-component";
import {useQuery} from "@tanstack/react-query";
import {cvQualificationService} from "../../../services/curriculum-resource-service";

const Qualifications = ({state, handleSelect, disabled}) => {
    const {data: qualificationOptions = [], isFetching} = useQuery({
        queryFn: () => cvQualificationService.options().then(({data}) => (
            data.map(({id, name}) => ({value: id, label: name}))
        )),
        queryKey: ["cv-qualifications-options"],
    });

    return (
        <div>
            <SelectComponent instanceId="qualifications" name="qualifications"
                             label="" options={qualificationOptions}
                             value={state.qualifications}
                             onChange={(value) => handleSelect("qualifications", value)}
                             isLoading={isFetching}
                             isDisabled={disabled}
                             isMulti
                             col="w-full"/>
        </div>
    );
};

export default Qualifications;
